import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAppStore } from '@/store/appStore'
import { ProtectedRoute } from '@/components/auth/ProtectedRoute'
import { appConfig } from '@/config/app'

interface RoleProtectedRouteProps {
  children: React.ReactNode
  requiredUsername: string
}

export const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({
  children,
  requiredUsername,
}) => {
  const user = useAppStore((state) => state.user)
  const location = useLocation()

  return (
    <ProtectedRoute>
      {user?.username === requiredUsername
        ? children
        : <Navigate to={appConfig.routes.root} state={{ from: location }} replace />}
    </ProtectedRoute>
  )
}